'use client'

import Link from 'next/link'
import { useSyncExternalStore } from 'react'

const APP_PREFIXES = [
  '/dashboard', '/jobs', '/clients', '/quotes', '/invoices',
  '/documents', '/notebook', '/inbox', '/operations', '/analytics',
  '/suppliers', '/settings', '/support', '/crm', '/calculators',
]

function isAppPath(pathname: string) {
  return APP_PREFIXES.some(p => pathname === p || pathname.startsWith(p + '/'))
}

function getReferrerHref(): string | null {
  try {
    const ref = document.referrer
    if (!ref) return null
    const url = new URL(ref)
    if (url.origin !== window.location.origin) return null
    if (isAppPath(url.pathname)) return url.pathname + url.search
  } catch {
    // malformed referrer — ignore
  }
  return null
}

export function NotFoundBackButton() {
  const backHref = useSyncExternalStore(
    () => () => {},
    getReferrerHref,
    () => null,
  )

  if (!backHref) return null

  return (
    <Link
      href={backHref}
      className="inline-flex items-center justify-center rounded-full border border-[var(--bb-border-strong)] px-5 py-2.5 text-sm font-semibold text-[var(--bb-foreground)] transition hover:bg-[var(--bb-surface-subtle)]"
    >
      Return to previous page
    </Link>
  )
}
